export const urls = {
  checkout: {
    japan: '/jp/チェックアウト',
    english: '/checkout',
  },
  products: {
    japan: '/jp/私のアカウント/products',
    english: '/my-account/products',
  },
  login: {
    japan: '/jp/チェックアウト?redirectTo=checkout',
    english: '/my-account?redirectTo=checkout',
  },
};
